import {Link} from "react-router-dom";

export default function MainBlockProcessing(props) {
    return (
        <section className="main_block main_block_processing">
            <div className="container">
                <div className="bread_crumbs">
                    <div>
                        <Link to="/">Главная</Link>
                    </div>
                    <div>></div>
                    <div>Политика обработки персональных данных</div>
                </div>
                <h1>
                    <span className="title main_title">Политика обработки персональных данных</span>
                </h1>
            </div>
        </section>
    )
}
